<ion-header class="ion-no-padding ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button fill="clear" color="dark" (click)="closeModal()">
        <ion-icon slot="icon-only" name="close-circle-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding-horizontal">
  <h3 class="ion-text-center">
    {{ "modals.benefits_modal.header" | translate }}
  </h3>
  <p class="desc-text">
    {{ "modals.benefits_modal.welcome_to_x_care" | translate }}
  </p>
  <p>{{ "modals.benefits_modal.start_exploring" | translate }}</p>
  <ul class="font14">
    <li>{{ "modals.benefits_modal.live_demo" | translate }}</li>
    <li>{{ "modals.benefits_modal.home_delivery" | translate }}</li>
    <li>{{ "modals.benefits_modal.dedicated_xpert" | translate }}</li>
    <li>{{ "modals.benefits_modal.call_back_assistance" | translate }}</li>
    <li>{{ "modals.benefits_modal.dedicated_calling_line" | translate }}</li>
    <li>{{ "modals.benefits_modal.doorstep_repair" | translate }}</li>
    <li>{{ "modals.benefits_modal.premium_point" | translate }}</li>
    <li>{{ "modals.benefits_modal.standby_device" | translate }}</li>
    <li>{{ "modals.benefits_modal.thank_you_call" | translate }}</li>
  </ul>
</ion-content>